import {ViewPopupLanguage} from '../../../shared/scripts/ui_popup/ViewPopupLanguage'
import {setElementInnerText, setElementOnClick} from '../../../shared/scripts/ui_utils/DomUtils'
import {createTooltipIn} from '../../../shared/scripts/ui_utils/TooltipUtils'
import {UIUtilsEjsVariables} from '../../../shared/scripts/UIUtilsEjsVariables'

export class UILanguageButtonController {
    constructor(container: HTMLDivElement) {
        const languageButton = container.getElementsByClassName('language-button')[0] as HTMLDivElement | undefined
        if(languageButton == undefined) return

        setElementOnClick(languageButton, () => {
            new ViewPopupLanguage()
        })
        createTooltipIn(languageButton, {key: 'strings:homePage.footer.changeLanguageButtonTooltip'}, 'top', undefined, 'small')
        const languageTextDiv = languageButton.querySelector('div')
        if(!languageTextDiv) return
        setElementInnerText(languageTextDiv, {key: 'strings:colonistCommon.utils.#buffer', options: {value: UIUtilsEjsVariables.language}})
    }
}

